import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPaymentConditionState, IPaymentConditionDropdown } from "../../../types/paymentConditions/paymentConditionInterfaces";

export const initialState: IPaymentConditionState = {
  paymentConditionDropdown: []
};

export const paymentConditionSlice = createSlice({
  name: 'paymentCondition',
  initialState,
  reducers: {
    loadingPaymentConditionDropdown: (state, action: PayloadAction<IPaymentConditionDropdown[]>) => {
      state.paymentConditionDropdown = action.payload;
    },
  }
});

export const { loadingPaymentConditionDropdown } = paymentConditionSlice.actions;

export default paymentConditionSlice.reducer;
